
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicleParts",
      function () {
        return require("private-next-pages/vehicleParts.js");
      }
    ]);
  